import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { TransportationTypes } from '@/utils/transportTypes'

export default function posmMixin () {
  const store = useStore()

  const transportType = ref<string | null>(localStorage.getItem('shippingMethod'))

  const items = computed(() => store.state.basket.items)

  watch(items, () => {
    transportType.value = localStorage.getItem('shippingMethod')
  }, { immediate: true })

  const isPosmOrder = computed(() => {
    return transportType.value === TransportationTypes.POSM
  })

  return isPosmOrder
}
